/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
    Renderer2,
} from '@angular/core';
import { ILogsStates, LogsStore } from '../../services/logs.store';
import { FilterOperatorType } from '../../logs.types';

import './log-filter.directive.less';

/**
 * @description
 *      Directive to style a clickable filter and add it to store upon click.
 * @author Zhiqian Liu, Alex Klyuev, Yogesh Patil
 */
@Directive({
    selector: '[logFilter]',
})
export class LogFilterDirective {
    /**
     * Property, operator, and value for a filter object.
     * See TFilterObj for reference.
     */
    @Input()
    public property: string;

    @Input()
    public operator = FilterOperatorType.EQUAL_TO;

    @Input()
    public value: string | number | boolean;

    /**
     * Event emitter for when filter is added.
     */
    @Output()
    public onFilterAdd = new EventEmitter<void>();

    constructor(
        elementRef: ElementRef,
        renderer: Renderer2,
        private readonly logsStore: LogsStore<ILogsStates>,
    ) {
        renderer.addClass(elementRef.nativeElement, 'log-filter');
    }

    /**
     * Add filter to store upon click.
     */
    @HostListener('click')
    public addFilter(): void {
        this.logsStore.addFilter({
            property: this.property,
            operator: this.operator,
            value: this.value,
        });

        this.onFilterAdd.emit();
    }
}
